var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVolume(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6314 6.35229C14.6314 4.63996 12.6198 3.71943 11.324 4.83881L7.61575 8.04219C7.25246 8.35601 6.78841 8.5287 6.30834 8.5287L4.49998 8.52871C3.11928 8.52872 2 9.64801 2 11.0287V14.7581C2 16.1388 3.11929 17.2581 4.5 17.2581H6.30838C6.78845 17.2581 7.25251 17.4308 7.6158 17.7446L11.324 20.9479C12.6198 22.0673 14.6314 21.1468 14.6314 19.4344V12.8934V6.35229Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7891 16.0517C18.45 15.1721 18.8417 14.0787 18.8417 12.8938C18.8417 11.709 18.45 10.6156 17.7891 9.73596",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8945 19.2097C21.2165 17.4504 21.9998 15.2636 21.9998 12.894C21.9998 10.5243 21.2165 8.33751 19.8945 6.57825",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolume);
export default __webpack_public_path__ + "static/media/volume.3118740a36b72a07b5aee0f323999fdc.svg";
export { ForwardRef as ReactComponent };